import { Card } from "@/types/v2/Card";
import { getEmployeeJobEntriesFromCard, JobEntry } from "@/lib/jobState";

export type JobRow = JobEntry;

/**
 * Flattens every card's per-job entries and filters to one employee —
 * the data source for the WEBV3-137 per-employee job drill-down.
 */
export function getJobRowsForEmployee(
  cards: Card[],
  employeeId: string
): JobRow[] {
  return cards
    .flatMap((card) => getEmployeeJobEntriesFromCard(card))
    .filter((entry) => entry.employeeId === employeeId);
}
